export const protocolOptions = [
  {
    value: 'FTP',
    description: 'externalStorage.ftp'
  },
  {
    value: 'FTPES',
    description: 'externalStorage.ftpes'
  },
  {
    value: 'FTPS',
    description: 'externalStorage.ftps'
  },
  {
    value: 'SFTP',
    description: 'externalStorage.sftp'
  }
];
